export default {"src":"/_next/static/media/black_project_cat_ic.af13ad0f.svg","height":120,"width":120};